<a
  class="item"
  data-testid="activity-feed-item"
  [attr.data-activity-type]="activity.type"
  [attr.data-message-id]="
    activity.type === 'Mention' ? activity.metadata.id : null
  "
  [routerLink]="effectiveRouterLink"
  (click)="itemClicked()"
  [queryParams]="
    activity.type === 'Mention' ? { message_id: activity.metadata.id } : {}
  "
>
  <div class="left">
    @if (activity.type === "Mention" || activity.type === "TeamOnOffCall") {
      <app-avatar
        [name]="
          activity.metadata.user.firstName +
          ' ' +
          activity.metadata.user.lastName
        "
        [userId]="activity.metadata.user.userId"
        [width]="50"
        [height]="50"
        [hasImage]="!!activity.metadata.user.profilePic"
        [showBadge]="true"
        [identityVerificationStatus]="
          activity.metadata.user.identityVerified ? 'Verified' : 'Unverified'
        "
        [isWorkspaceVerified]="activity.metadata.user.workspaceVerified"
        [isProfessionVerified]="activity.metadata.user.professionVerified"
        [user]="activity.metadata.user"
      >
      </app-avatar>
    }

    @if (activity.type === "WorkspaceJoined") {
      <div>
        @if (!!activity.metadata.profilePic) {
          <app-avatar
            [name]="'Workspace'"
            [width]="50"
            [height]="50"
            [hasImage]="!!activity.metadata.profilePic"
            [picUrl]="activity.metadata.profilePic"
            [showBadge]="false"
          >
          </app-avatar>
        }
        @if (!activity.metadata.profilePic) {
          <div class="icon">
            <img src="../../../../assets/icons/ic-workplace.svg" alt="" />
          </div>
        }
      </div>
    }
  </div>

  <div class="content celo-elipsis-2">
    @if (activity.type === "WorkspaceJoined") {
      <div>
        <div class="title">{{ activity.metadata.content }}</div>
        <div class="subtitle">{{ activity.metadata.name }}</div>
      </div>
    }

    <div [ngClass]="{ unread: !activity.metadata.read }">
      @if (activity.type === "Mention" || activity.type === "TeamOnOffCall") {
        <div>
          <div class="title">
            <span>{{ activity.metadata.user.firstName }}</span
            >&nbsp;
            <span>{{ activity.metadata.user.lastName }}</span>
          </div>
          @if (activity.type === "Mention") {
            <div class="subsubtitle">
              Mentioned you
              @if (
                activity.metadata.conversationType !== "Chat" &&
                activity.metadata.conversationType !== "SelfChat"
              ) {
                <span>in {{ activity.metadata.name }}</span>
              }
            </div>
          }
          @if (activity.type === "TeamOnOffCall") {
            <div class="subsubtitle">
              {{ activity.metadata.name }}
            </div>
          }
          <div
            class="subtitle"
            [ngClass]="{
              deleted:
                activity.metadata.deletedOnUtc !== null &&
                activity.metadata.deletedOnUtc !== undefined,
            }"
          >
            {{ activity.metadata.content }}
          </div>
        </div>
      }
    </div>
  </div>

  <div class="right">
    <span class="time">{{
      activity.timeStampUtc | dateFormat: "shortTime"
    }}</span>
    @if (activity.metadata.read === false) {
      <div class="icon"></div>
    }
  </div>
</a>
